export default ()=>({
    status: 'authenticating',
    user: null,
    idToken: null,
   })
    